import { SET_LOCATIONS_DATA } from '../actions/types';

const initialState = {
	allLocations: null,
	error: null,
	isLoading: false
};

export default function locationsReducer(state = initialState, action) {
	switch (action.type) {
		case SET_LOCATIONS_DATA:
			return {
				...state,
				allLocations: action.payload.error
					? null
					: action.payload.locations,
				error: action.payload.error || null,
				isLoading: action.payload.isLoading || false
			};
		default:
			return state;
	}
}
